import formatNumberWithComma from './formatNumberWithComma.mjs';

/**
 * 만 단위 이상 금액을 표기하는 함수입니다.
 *
 * @param value - 원하는 값
 * @returns
 * 205000 => 20억 5,000만
 * 4000 => 4,000만
 * 260 => 260만
 * -1000 => -1,000만
 * 0 => '' (천원이하 버림)
 *
 * @param {boolean} options.dropLessThanThousand - 천 원이하 소수점 버릴지 여부
 * @default true
 * @returns
 * 18.2 => 18.2만
 */
function formatTenThousandUnitsAmount(value) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    dropLessThanThousand: true
  };
  if (Number.isNaN(+value)) {
    return '';
  }
  const TEN_THOUSAND_UNITS = 10000;
  const numberValue = typeof value === 'string' ? +value : value;
  const quotient = Math.trunc(numberValue / TEN_THOUSAND_UNITS); // 몫

  const [integer, point] = `${value}`.split('.');
  const remainderOfInteger = +integer % TEN_THOUSAND_UNITS;
  const remainderOfPoint = options?.dropLessThanThousand ? 0 : point ? +point / Math.pow(10, point.length) : 0;
  const remainder = remainderOfInteger + remainderOfPoint;
  const formattedQuotient = quotient !== 0 ? `${formatNumberWithComma(quotient)}억` : '';
  const formattedRemainder = remainder !== 0 ? `${formatNumberWithComma(remainder)}만` : '';
  const separator = formattedQuotient && formattedRemainder ? ' ' : '';
  return formattedQuotient + separator + formattedRemainder;
}

export { formatTenThousandUnitsAmount as default };
